import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ObservacaoModal from './ObservacaoModal';
import './PatientDetailsModal.css';

function PatientDetailsModal({ isOpen, onClose, paciente }) {
  const [isObservacaoModalOpen, setIsObservacaoModalOpen] = useState(false);
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      modalRef.current.focus();
    }
  }, [isOpen]);

  // Fechar o modal ao pressionar a tecla Escape
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  // Função para formatar datas
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? 'Data inválida'
      : date.toLocaleDateString('pt-BR');
  };

  if (!isOpen || !paciente) return null;

  const handleOpenObservacaoModal = () => {
    setIsObservacaoModalOpen(true);
  };

  const handleCloseObservacaoModal = () => {
    setIsObservacaoModalOpen(false);
  };

  return (
    <div
      className="patient-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      ref={modalRef}
      tabIndex="-1"
    >
      <div className="patient-modal-content">
        <button
          className="patient-modal-close-button"
          onClick={onClose}
          aria-label="Fechar Modal"
          ref={closeButtonRef}
        >
          &times;
        </button>
        <header>
          <h2 id="modal-title">Detalhes do Paciente</h2>
        </header>
        <div id="modal-description" className="patient-details">
          <div className="patient-detail">
            <strong>Nome:</strong> {paciente.nome || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>CPF:</strong> {paciente.cpf || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Clínica:</strong> {paciente.clinica || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Telefone:</strong> {paciente.telefone || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Email:</strong> {paciente.email || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Endereço:</strong> {paciente.endereco || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Plano:</strong> {paciente.plano || 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Data de Nascimento:</strong>{' '}
            {paciente.dataNascimento
              ? formatDate(paciente.dataNascimento)
              : 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Data de Atendimento:</strong>{' '}
            {paciente.dataAtendimento
              ? formatDate(paciente.dataAtendimento)
              : 'Não informado'}
          </div>
          <div className="patient-detail">
            <strong>Anamnese/Observações:</strong>
            {paciente.observacoes ? (
              <>
                <button
                  className="px-6 py-2.5 rounded-lg shadow-md text-base font-medium transition transform duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-opacity-50 active:scale-95 bg-gradient-to-r rounded-3x1 from-primary to-primary-hover text-white hover:from-primary-hover hover:to-secondary"
                  onClick={handleOpenObservacaoModal}
                  aria-label="Ver Anamnese"
                >
                  Ver Anamnese
                </button>
                <ObservacaoModal
                  isOpen={isObservacaoModalOpen}
                  onClose={handleCloseObservacaoModal}
                  value={paciente.observacoes}
                  onChange={() => {}}
                  callerComponent="PatientEditModal"
                  isReadOnly={true}
                />
              </>
            ) : (
              'Não informado'
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

PatientDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  paciente: PropTypes.shape({
    nome: PropTypes.string,
    cpf: PropTypes.string,
    clinica: PropTypes.string,
    telefone: PropTypes.string,
    email: PropTypes.string,
    endereco: PropTypes.string,
    plano: PropTypes.string,
    dataNascimento: PropTypes.string,
    dataAtendimento: PropTypes.string,
    observacoes: PropTypes.string,
  }),
};

export default PatientDetailsModal;
